import { Component, OnInit, Input, EventEmitter, Output, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-drop-down',
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.css']
})
export class DropDownComponent implements OnInit, AfterViewInit {
  ngAfterViewInit(): void {
  }
  @Input() property : string;
  @Input() model : any;
  @Input() label : string;
  @Input() valueLabel : string;
  @Input() values : Array<any>;
  @Output() modelChanged = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  onChange()
  {
    this.modelChanged.emit({
      name: this.property,
      value: this.model
    })
  }
}
